import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import {
	FormHelperText,
	InputLabel,
	MenuItem,
	FormControl,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDeleteSubcategoryMutation } from "../../../services/queryHooks";
import { useTranslation } from "react-i18next";

export default function DeleteSubcategoryModal({
	isOpen,
	categoryGroupId,
	categoryType,
	subcategory,
	categories,
	onClose,
}) {
	const { mutate } = useDeleteSubcategoryMutation();
	const handleSubmit = () => {
		if (assignNewCategory && newCategoryId === "") {
			setErrorCategory(t("categoryGroupRequired"));
			return;
		}
		mutate({
			categoryGroupId: categoryGroupId,
			subcategoryId: subcategory._id,
			newCategoryId,
			newSubcategoryId,
		});
		onClose();
	};
	const { t } = useTranslation();
	const theme = useTheme();
	const [assignNewCategory, setAssignNewCategory] = useState(false);
	const [newCategoryId, setNewCategoryId] = useState("");
	const [newSubcategoryId, setNewSubcategoryId] = useState("");
	const [errorCategory, setErrorCategory] = useState("");

	useEffect(() => {
		if (isOpen) {
			setAssignNewCategory(false);
			setNewCategoryId("");
			setNewSubcategoryId("");
			setErrorCategory("");
		}
	}, [isOpen]);

	const handleAssignNewCategoryChange = (event) => {
		setAssignNewCategory(event.target.checked);
		if (!event.target.checked) {
			setNewCategoryId("");
			setNewSubcategoryId("");
			setErrorCategory("");
		}
	};

	const handleCategoryChange = (event) => {
		setNewCategoryId(event.target.value);
		setNewSubcategoryId("");
	};

	const handleSubcategoryChange = (event) => {
		setNewSubcategoryId(event.target.value);
	};
	return (
		<>
			<Dialog
				open={isOpen}
				onClose={onClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				disableEnforceFocus
			>
				<DialogTitle id="alert-dialog-title">
					{t("deleteSubcategoryTitle")}
				</DialogTitle>
				<DialogContent>
					<FormControlLabel
						control={
							<Checkbox
								checked={assignNewCategory}
								onChange={handleAssignNewCategoryChange}
								color="primary"
							/>
						}
						label={t("reassignTransactions")}
						sx={{ mt: 2 }}
					/>
					{assignNewCategory && (
						<FormControl fullWidth sx={{ mt: 2 }} size="small">
							<InputLabel>{t("categoryGroup")}</InputLabel>
							<Select
								required
								value={newCategoryId}
								label={t("categoryGroup")}
								onChange={handleCategoryChange}
								error={errorCategory !== ""}
							>
								{categories &&
									categories
										.filter((category) => {
											return (
												category.type === categoryType
											);
										})
										.map((category) => (
											<MenuItem
												key={category._id}
												value={category._id}
											>
												{category.groupName
													? category.groupName
													: t(
															category.groupTranslationKey
														)}
											</MenuItem>
										))}
							</Select>
						</FormControl>
					)}
					{errorCategory !== "" && (
						<FormHelperText
							sx={{ ml: 2, color: theme.palette.error.main }}
						>
							{errorCategory}
						</FormHelperText>
					)}
					{assignNewCategory && newCategoryId && (
						<>
							<FormControl fullWidth sx={{ mt: 2 }} size="small">
								<InputLabel>{t("category")}</InputLabel>
								<Select
									required
									value={newSubcategoryId}
									label={t("category")}
									onChange={handleSubcategoryChange}
								>
									{newCategoryId &&
										categories
											.find(
												(item) =>
													item._id === newCategoryId
											)
											?.subcategories?.filter(
												(subcat) =>
													subcat._id !==
													subcategory._id
											)
											.map((subcategory) => (
												<MenuItem
													value={subcategory._id}
													key={subcategory._id}
												>
													{subcategory.name
														? subcategory.name
														: t(
																subcategory.translationKey
															)}
												</MenuItem>
											))}
								</Select>
							</FormControl>
						</>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>{t("cancel")}</Button>
					<Button
						variant="contained"
						color="error"
						onClick={handleSubmit}
					>
						{t("delete")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
